import {getInputControlMeta} from '@wix/wix-events-commons-statics'
import React, {useEffect, useState} from 'react'
import {Label} from '../../commons/label'
import {Select} from '../../commons/select'
import fs from '../../fields.scss'
import {DropdownProps} from './interfaces'

export const Dropdown = ({input, control}: DropdownProps) => {
  const [selectedValue, setSelectedValue] = useState(null)
  const options: string[] = getInputControlMeta(control).options
  const {label} = getInputControlMeta(control)

  const onChange = (selectedOption: string) => {
    input.onChange(selectedOption)
    setSelectedValue(selectedOption)
  }

  useEffect(() => {
    if (!selectedValue) {
      if (input.value) {
        onChange(input.value)
      } else if (options.length) {
        onChange(options[0])
      }
    }
  }, [])

  return (
    <div className={fs.field}>
      <Label classes={fs.customCaption} dataHook="dropdown-caption" required={false} caption={label} />
      <Select options={options} value={selectedValue} ariaLabel={label} onChange={onChange} />
    </div>
  )
}
